import { useParams } from 'react-router-dom';
import { useExportSalesPromoParticipantList, useGetSalesPromoDetailParticipantSummary, useSalesPromoParticipantList } from '../../../providers/SalesPromo.provider';

export function useSalesPromoDetailTabParticipant() {
  const params = useParams<{ id: string }>();

  const participantList = useSalesPromoParticipantList(params.id);
  const exportParticipantList = useExportSalesPromoParticipantList(params.id);
  const participantSummary = useGetSalesPromoDetailParticipantSummary(params.id);

  return {
    participantList,
    exportParticipantList,
    participantSummary,
    params
  };
}
